import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import { PassouFalhouEnum } from '../../enums-consultaSeguimento'
import { hasAnySim, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta06Model,
  ConsultaSeguimentoPergunta06PegarEnum,
} from './model-consultaSeguimentoPergunta06'

const pergunta06PegarEnum = Object.values(ConsultaSeguimentoPergunta06PegarEnum)

export const isPergunta06PegarAllNao = (value: ConsultaSeguimentoPergunta06Model['PERGUNTA_06_PEGAR']): boolean => {
  return isAllNao(value, pergunta06PegarEnum)
}

export function prunePergunta06(value: ConsultaSeguimentoPergunta06Model): ConsultaSeguimentoPergunta06Model {
  const pruned: ConsultaSeguimentoPergunta06Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_06_HEADER: value.PERGUNTA_06_HEADER,
  }

  const isHeaderNao = value.PERGUNTA_06_HEADER === SimNaoEnum.NAO
  const isNotAllNao = !isPergunta06PegarAllNao(value.PERGUNTA_06_PEGAR)

  if (isHeaderNao) {
    pruned.PERGUNTA_06_PEGAR = value.PERGUNTA_06_PEGAR
  }

  if (isHeaderNao && isNotAllNao) {
    pruned.PERGUNTA_06_APONTAR_PARA = value.PERGUNTA_06_APONTAR_PARA
  }

  return pruned
}

export function conditionToCalculatePergunta06(values: ConsultaSeguimentoPergunta06Model): boolean {
  if (
    values?.PERGUNTA_06_HEADER === SimNaoEnum.SIM ||
    isPergunta06PegarAllNao(values?.PERGUNTA_06_PEGAR) ||
    (hasAnySim(values?.PERGUNTA_06_PEGAR) && !isEmpty(values?.PERGUNTA_06_APONTAR_PARA))
  ) {
    return true
  }
  return false
}

export function calculateResultadoPergunta06(values: ConsultaSeguimentoPergunta06Model): PassouFalhouEnum | undefined {
  if (values?.PERGUNTA_06_HEADER === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  } else if (isPergunta06PegarAllNao(values?.PERGUNTA_06_PEGAR)) {
    return PassouFalhouEnum.FALHOU
  } else if (values?.PERGUNTA_06_APONTAR_PARA === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  } else if (values?.PERGUNTA_06_APONTAR_PARA === SimNaoEnum.NAO) {
    return PassouFalhouEnum.FALHOU
  }
}
